import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckGNBIdsFilter } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_GNB_IDS } from '@constants/queryKeys';

interface IUseQueryHistoryCheckGNBIdsFilterReturnValue {
	gnbIdsOptions: TSelectOption[];
	isLoadingGnbIdsOptions: boolean;
}

const useQueryHistoryCheckGNBIdsFilter = (
	comparisonId: string,
): IUseQueryHistoryCheckGNBIdsFilterReturnValue => {
	const {
		data: gnbIdsOptions,
		isLoading,
		isFetching,
	} = useQuery<string[], TSelectOption[]>({
		queryKey: [CONSISTENCY_GNB_IDS, comparisonId],
		queryFn: extractQueryParams(getHistoryCheckGNBIdsFilter),
		select: (options) => fieldsOptionsFormatted(options.filter(option => option !== null) || []),
		enabled: [comparisonId],
		...refetchOptions,
	});

	return {
		gnbIdsOptions: gnbIdsOptions || [],
		isLoadingGnbIdsOptions: (isLoading && !!gnbIdsOptions)
			|| isFetching,
	};
};

export default useQueryHistoryCheckGNBIdsFilter;
